module.exports = __webpack_public_path__ + "img/s45.fcd4ed1d.png";